<template>
  <svg
    class="app-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
    v-html="body"
  />
</template>

<script>
/**
 * One App shell icon (24×24 stroke grid, stroke = currentColor). `name` is a key of SHELL_ICONS
 * (src/components/AppShell/icons.js — constant SVG bodies from the design export, never user data).
 * An unknown name draws an empty box of the same size, so the row layout never shifts.
 */
import { SHELL_ICONS } from './icons';

export default {
  name: 'AppIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 18 },
    stroke: { type: [Number, String], default: 1.9 },
  },
  computed: {
    body() {
      return Object.prototype.hasOwnProperty.call(SHELL_ICONS, this.name) ? SHELL_ICONS[this.name] : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.app-icon {
  display: block;
  flex: none;
}
</style>
